import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedReduxRedirect  } from 'redux-auth-wrapper/history4/redirect'
//import LoadingScreenComponent from './main/LoadingScreenComponent'; // change it to your custom component
import { routerActions } from 'react-router-redux'
const locationHelper = locationHelperBuilder({});

const UserIsAuthenticated = connectedReduxRedirect ({
  wrapperDisplayName: 'UserIsAuthenticated',
  //AuthenticatingComponent: LoadingScreenComponent,
  allowRedirectBack: true,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/signin',
  authenticatingSelector: ({ firebase: { auth, profile, isInitializing } }) =>
    !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
    auth.isLoaded && !auth.isEmpty,
    redirectAction: routerActions.replace
  
})

const UserIsNotAuthenticated = connectedReduxRedirect ({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  //AuthenticatingComponent: LoadingScreenComponent,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/',
  authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
    !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
    auth.isLoaded && auth.isEmpty,
  redirectAction: routerActions.replace

});

export {UserIsAuthenticated, UserIsNotAuthenticated}


// WEBPACK FOOTER //
// ./src/route.js